export default __webpack_public_path__ + "static/media/VIDEO_VIEW_ICON.7a0a9ee9.png";